module.exports = __webpack_public_path__ + "d7ebb28cc4ba6c5e5fca2c17727647f6.svg";